// Staging server API
export const apiUrl = "https://backend.theprofit.ai";
// Production server API
// export const apiUrl = "http://139.59.42.133:8000/";
// Testing url
// export const apiUrl = "https://da716e6bf918.ngrok-free.app";
